import React from 'react'
import styled from 'styled-components'

import { media, THEME } from '../../styles'
import Icon from '../Icon'
import Skeleton from '../Skeleton'

const Styled = styled.div`
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  background-color: ${({ backgroundColor }) =>
    backgroundColor || THEME.COLORS.background.primary};
  padding: 1.6rem 2.4rem;
  ${media.medium`
    padding: 1.6rem 3.2rem;
  `}
`
Styled.characteristic = styled(({ tagName: TagName = 'div', ...rest }) => (
  <TagName {...rest} />
))`
  flex: 1;
  display: block;
  text-decoration: none;
`
Styled.characteristicIcon = styled(Icon)`
  width: 3.2rem;
  height: 3.2rem;
  margin-bottom: 0.8rem;
  display: inline-block;
`
Styled.characteristicContainer = styled.div`
  text-align: center;
  font-size: 1.3rem;
  color: ${({ textColor }) => textColor || THEME.COLORS.foreground.primary};

  & strong {
    font-size: 1.7rem;
    font-weight: 500;
    line-height: 1;
    display: block;
  }
`
Styled.textSkeleton = styled(Skeleton)`
  width: 8rem;
  height: 1.6rem;
  margin: 0 auto;
  display: inline-block;
  border-radius: 1.5rem;
`

export default Styled
